module.exports = __webpack_public_path__ + "static/media/paid.ab205af7.png";